import React from 'react';
import { HomeHero } from '../components/home/HomeHero';
import { MadeHere } from '../components/home/MadeHere';
import { SupplyList } from '../components/home/SupplyList';
import { QuoteSection } from '../components/home/QuoteSection';
import { MissionVision } from '../components/shared/MissionVision';
import { OrderSteps } from '../components/shared/OrderSteps';
import { FaqList } from '../components/shared/FaqList';
export function Home() {
  return <>
      <HomeHero data-id="element-345" data-mp="1zka7r549rrja" />
      <MadeHere data-id="element-346" data-mp="24gsfmduwc5zu" />
      <SupplyList data-id="element-347" data-mp="24g8w4spll9jp" />
      <MissionVision tone="coal" data-id="element-348" data-mp="24htrgkjqkwim" />
      <OrderSteps data-id="element-349" data-mp="24ivb3detirby" />
      <section className="bg-coal py-20 md:py-32" aria-labelledby="faq-heading" data-id="element-350" data-mp="29gd9waz4fq68">
        <div className="mx-auto grid max-w-[1320px] gap-10 px-5 md:px-8 lg:grid-cols-12 lg:gap-12" data-id="element-351" data-mp="29ihmriezzzin">
          <h2 id="faq-heading" className="font-display text-5xl font-bold uppercase leading-[0.9] text-chalk md:text-7xl lg:col-span-4" data-id="element-352" data-mp="3kvaewubpapz8">
            Frequently Asked <span className="text-flame" data-id="element-353" data-mp="3oyq9zm84gi9t">Questions</span>
          </h2>
          <div className="lg:col-span-8" data-id="element-354" data-mp="30w9l2xnbqex2">
            <FaqList data-id="element-355" data-mp="2vxottnq1v5kr" />
          </div>
        </div>
      </section>
      <QuoteSection data-id="element-356" data-mp="2vyhse1euuort" />
    </>;
}